import { Modal } from 'antd'
import type { FC } from 'react'
import styles from './patient-info-dialog.module.scss'
import { Patient } from 'features/Procedure/state/procedure-api.type'
import { formatDate } from 'common/services/format'

type Props = {
  isOpen: boolean
  onClose: () => void
  patientInfo: Patient | null
}

export const PatientInfoDialog: FC<Props> = ({ isOpen, onClose, patientInfo }) => {
  if (!patientInfo) return null
  const patientName = `${patientInfo?.last_name || 'N/A'}, ${patientInfo?.first_name ?? ''}`
  const stateZip = [patientInfo?.state, patientInfo?.zip_code].filter(Boolean).join(' ')
  const fullAddress = [patientInfo?.address, patientInfo?.city, stateZip]
    .filter(Boolean)
    .join(', ')

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      classNames={{
        content: styles.modalContent,
      }}>
      <div className={styles.container}>
        <h1 className={styles.patientName}>{patientName}</h1>

        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>Contact</h3>
          <div className={styles.contactInfo}>
            <div className={styles.contactRow}>
              <span className={styles.label}>DOB:</span>
              <span className={styles.value}>{formatDate(patientInfo?.dob)}</span>
              <span className={styles.label}>Age:</span>
              <span className={styles.value}>{patientInfo?.age || 'N/A'}</span>
            </div>
            {fullAddress && (
              <div className={styles.contactRow}>
                <span className={styles.value}>{fullAddress}</span>
              </div>
            )}
          </div>
        </section>

        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>Billing Notes</h3>
          <div className={styles.noteText}>{patientInfo?.billing_note || 'N/A'}</div>
        </section>

        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>General Note</h3>
          <div className={styles.noteText}>{patientInfo?.general_note || 'N/A'}</div>
        </section>
      </div>
    </Modal>
  )
}
